import { render } from "./ModaImageCard.vue?vue&type=template&id=804fc338&scoped=true"
import script from "./ModaImageCard.vue?vue&type=script&lang=js"
export * from "./ModaImageCard.vue?vue&type=script&lang=js"

import "./ModaImageCard.vue?vue&type=style&index=0&id=804fc338&scoped=true&lang=css"

import exportComponent from "/Users/thanyakornphanthamit/Desktop/vue/wedday/guest-registation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804fc338"]])

export default __exports__